import { DateTime } from 'luxon';
import { axiosAPI } from './API';

export interface ITimeZoneItem {
    label: string,
    value: string,
}

// Singleton for time zone stuff
class _TimeZoneService {
    public browserTimeZone: string;
    public luxonDefaultTimezone = 'local';
    private serverTimeZonesPromise: Promise<string[]>;
    // The user's selected timezone is available from UsersService.me.timezone
    
    constructor() {
        this.browserTimeZone = this.getBrowserTimeZone();
    }

    public getServerTimeZones(): Promise<string[]> {
        // Cache the results, these aren't going to change.
        if (!this.serverTimeZonesPromise) {
            this.serverTimeZonesPromise = axiosAPI.get<string[]>(`/timezones`)
                .then((response) => {
                    return response.data;
                })
            this.serverTimeZonesPromise.catch((err) => {
                console.error('Error loading timezones', err);
            })
        }

        return this.serverTimeZonesPromise;
    }

    // https://stackoverflow.com/questions/1091372/getting-the-clients-time-zone-and-offset-in-javascript
    private getBrowserTimeZone(): string {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
    }

    public isValidTimeZone(timeZone: string): boolean {
        const dt = DateTime.now().setZone(timeZone);
        return dt.isValid;
    }
}

export const TimeZoneService = new _TimeZoneService();
